import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legislatie-cadre-medicale',
  templateUrl: './legislatie-cadre-medicale.component.html',
  styleUrls: ['./legislatie-cadre-medicale.component.scss']
})
export class LegislatieCadreMedicaleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
